import { collection, getDocs } from "firebase/firestore";
import { useLoaderData } from "react-router-dom";
import ExportTableAsCSV from "../components/ExportTableAsCSV";
import { db } from "../firebase/config";

const COLLECTION_NAME = "ford-event-game-july-2026";

function booleanLabel(value) {
  return value ? "Да" : "Не";
}

function FordEventGameRequests() {
  const usersList = [];
  const result = useLoaderData(fordEventGameRequestsLoader);

  result.forEach((doc) => {
    usersList.push({ id: doc.id, ...doc.data() });
    usersList.sort((a, b) => b.date - a.date);
  });

  return (
    <div className="container py-8 mx-auto">
      <ExportTableAsCSV
        tableData={document.querySelector(".ford-event-game-requests-table")}
        fileName="Ford-Event-Game-July-2026.csv"
      />
      <div className="grid grid-cols-9 gap-2 p-2 text-white bg-fordBlue ford-event-game-requests-table">
        <h4>Име</h4>
        <h4 className="text-center">Телефон</h4>
        <h4 className="text-center">Имейл</h4>
        <h4 className="text-center">Профил</h4>
        <h4 className="text-center">Опит</h4>
        <h4 className="text-center">Покупка</h4>
        <h4 className="text-center">Маркетинг</h4>
        <h4 className="text-center">Двоен шанс</h4>
        <h4 className="text-center">Дата</h4>
      </div>
      {usersList.map((user) => (
        <div
          className="grid grid-cols-9 gap-2 p-2 border-b text-fordBlue even:bg-gray-50 hover:bg-gray-200 offerTableRow"
          key={user.id}
        >
          <p>{user.fullName}</p>
          <p className="text-center">{user.phone}</p>
          <p className="text-center">{user.email}</p>
          <p className="text-center">{user.socialHandle || "-"}</p>
          <p className="text-center">{user.drivingExperience}</p>
          <p className="text-center">{user.purchasePlan}</p>
          <p className="text-center">{booleanLabel(user.marketingConsent)}</p>
          <p className="text-center">{booleanLabel(user.socialShareBonus)}</p>
          <p className="text-center">
            {user.date?.toDate?.().toLocaleDateString("bg-BG")}
          </p>
        </div>
      ))}
    </div>
  );
}

export default FordEventGameRequests;

export const fordEventGameRequestsLoader = async () => {
  const querySnapshot = await getDocs(collection(db, COLLECTION_NAME));
  return querySnapshot;
};
